import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject, Observable } from 'rxjs';
import { CommonsService } from './commons.service';
import { MessagesService } from './messages.service';
import { MachineServiceData, MachineServiceDataService, User, UsersService } from 'src/api/generated';

@Injectable({
  providedIn: 'root'
})
export class ServiceDataService {

  public dataSource: DataSource<MachineServiceData, string>;

  private _oneEntity: BehaviorSubject<MachineServiceData | null> = new BehaviorSubject<MachineServiceData | null>(null);
  public oneEntity$: Observable<MachineServiceData | null> = this._oneEntity.asObservable();

  private _usersCache: BehaviorSubject<User[]> = new BehaviorSubject<User[]>([]);
  public usersCache$: Observable<User[]> = this._usersCache.asObservable();

  constructor(
    private _commonSvc: CommonsService,
    private _MachineServiceDataSvc: MachineServiceDataService,
    private _usersSvc: UsersService,
    private _spinner: NgxSpinnerService,
    private _msgSvc: MessagesService,
    ){
    this.dataSource = _commonSvc.makeAsyncDataSource<MachineServiceData, string, MachineServiceDataService>(this._MachineServiceDataSvc, undefined);
    this.refreshusersCache();
  }

  public Deleted(id: string): void {
    this._MachineServiceDataSvc._delete(id).subscribe({
      next: () => {
        this.dataSource.reload()
      },
      error: (e: HttpErrorResponse) => {
        this._msgSvc.ShowError(e.message);
      }
    });
  }

  public LoadOne(id: string): void{
    this._MachineServiceDataSvc.getOne(id).subscribe({
      next: res => {
        this._oneEntity.next(res);
      },
      error: (e: HttpErrorResponse) => {
        this._msgSvc.ShowError(e.message);
      }
    });
  }

  public SaveDuplicate(data: MachineServiceData): void {
    this._spinner.show();
    this._MachineServiceDataSvc.postSaveDuplicateMachineServiceData(data).subscribe({
      next: () => {
        this.dataSource.reload()
        setTimeout(() => {
          this._spinner.hide();
        }, 200);
      },
      error: e => {
        setTimeout(() => {
          this._spinner.hide();
        }, 200);
      }
    });
  }

  public refreshusersCache() {
    this._usersSvc.postList({
      Filter: [["Tags", "Contains", "Right:MAINTAINER"],"or",["Tags", "Contains", "Right:ADMIN"],"or",["Tags", "Contains", "Right:SUPERADMIN"]]
    }).subscribe({
        next: (res: any) => {
          this._usersCache.next(res.data ?? []);
        },
        error: e => {
          this._msgSvc.ShowError(e);
        }
      });
  }

  public get AllUsers(): User[]{
    return this._usersCache.value;
  }

  public getUserNameById(value: string): string {
    const o = this._usersCache.value.find(o => o.Id == value);

    if (o != undefined) {
      return o.Name ?? '';
    }

    return value;
  }
}
